import known from "../../../shared/known-experiences.json";

const KNOWN_BEVERAGE_IDS = new Set(known.beverageIds);
const PASSION_EXPERIENCE_IDS = new Set(known.passionIds);
const MAX_EXPERIENCE_ID_LENGTH = 32;

export function sanitizeExperienceId(raw) {
  if (typeof raw !== "string") {
    return "";
  }
  const id = raw.trim().toLowerCase().slice(0, MAX_EXPERIENCE_ID_LENGTH);
  if (KNOWN_BEVERAGE_IDS.has(id) || PASSION_EXPERIENCE_IDS.has(id)) {
    return id;
  }
  return "";
}

export function resolveExperienceFamily(experienceId) {
  if (KNOWN_BEVERAGE_IDS.has(experienceId)) {
    return "beverages";
  }
  if (PASSION_EXPERIENCE_IDS.has(experienceId)) {
    return "passions";
  }
  return "unknown";
}
